<template>
  <div class="schedule-content">
    <b-overlay
      variant="white"
      :show="displayOverlay"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <div class="block-button">
        <vs-button
          v-if="!listEmpty"
          class="btn-clear-playlist"
          type="flat"
          @click.stop="clearList()"
          >{{ $t("SCHEDULE").Clean }}</vs-button
        >
      </div>
      <li
        class="cursor-pointer email__mail-item mb-1"
        v-for="(item, index) in listNews"
        :key="index + 1"
        @click.stop="$emit('open-news-detail', item)"
      >
        <informative-list-item
          :schedule="true"
          :data="item"
          :isDesktop="true"
          :isAuthenticated="true"
          :currentCommodity="{ id: 99 }"
          :contentId="0"
          :canDisplaySave="false"
          :canDisplayRemove="true"
          @remove-news="removeNews"
        />
      </li>

      <div class="empty-playlist" v-if="displayEmptyText">
        <feather-icon icon="CalendarIcon" class="ml-5" :svgClasses="['h-12 w-12 icon-safra icon-primary']" />
        <!-- <feather-icon icon="ListIcon" class="ml-5" svg-classes="h-12 w-12" /> -->
        <h3>{{$t('SCHEDULE').Empty_Schedule}}</h3>
        <h6>{{$t('SCHEDULE').Empty_Schedule_Text}}</h6>
      </div>
    </b-overlay>
  </div>
</template>

<script>

import messageDialogHelper from "../../../../helpers/message-dialog-helper";
import messagesNotifyHelper from "../../../../helpers/messages-notify-helper";
import reportService from "../../../../providers/reportService";
import InformativeListItem from "../../../../views/pages/informative/InformativeListItem.vue";
export default {
  components: {
    InformativeListItem,
  },
  data() {
    return {
      listNews: [],
      displayOverlay: false,
      displayEmptyText: false
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    listEmpty() {
      return this.listNews.length == 0;
    },
    scheduleData() {
      return this.$store.state.scheduleData;
    },
  },
  methods: {
    clearList() {
      messageDialogHelper.displayDialogConfirm(
        "Agenda",
        "Deseja limpar sua agenda?",
        (callback) => {
          if (callback == "accept") {
            this.$store.dispatch("clearScheduleData");
            messagesNotifyHelper.successNotify(
              "Agenda",
              "Sua agenda foi limpa com sucesso"
            );
          }
        }
      );
    },
    removeNews(dataNews) {
      this.$store.dispatch("removeScheduleData", dataNews);
      setTimeout(() => {
        messagesNotifyHelper.successNotify(
          "Agenda",
          "Evento removido da sua agenda"
        );
        this.fetchData();
      }, 1000);
    },
    fetchData() {
      this.displayOverlay = true;
      this.displayEmptyText = false;
      const params = new URLSearchParams();
      params.append("schedule", true);
      reportService
        .getListNewsById(this.scheduleData, params)
        .then((res) => {
          this.displayOverlay = false;
          this.listNews = res;
          if (this.listNews.length == 0) this.displayEmptyText = true;
        })
        .catch((err) => {
          this.displayOverlay = false;
          this.displayEmptyText = true;
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>